<script setup lang="ts">
const store = useCategoryStore()
const { recommended } = storeToRefs(store)
</script>

<template>
  <div v-if="recommended?.elements.length">
    <div class="text-18 font-bold text-primary">
      Polecane produkty
    </div>
    <ul class="flex flex-nowrap overflow-y-auto gap-[10px] snap-x md:snap-none snap-mandatory mt-[10px]">
      <li v-for="product in recommended.elements" :key="product.id" class="shrink-0 basis-[calc(50%-5px)] md:basis-[calc(25%-7.5px)] snap-center group w-[calc(50%-5px)] md:w-[calc(25%-10px)] max-w-[262px]">
        <ProductListItem :products="product" class="mb-[30px]" />
      </li>
    </ul>
  </div>
</template>
